import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    code:''
  },
  getters: {
  },
  mutations: {
    SET_CODE:(state,data)=>{
      state.code=data
    }
  },
  actions: {
  },
  modules: {
  }
})
